export const debugLog = (message: string) => {
    const releaseType = process.env.RELEASE_TYPE ?? 'local';

    if (releaseType !== 'production') {
        console.debug(message);
    }
};
